export enum TealiumContractType {
  Contract = 'contract',
  Ad_Pack = 'ad-pack',
  Casual = 'casual',
}

export enum TealiumPricingType {
  Variable = 'variable',
  Fixed = 'fixed',
}
